module.exports = {
	container: {
		center: true,
		padding: "15px",
	},
	extend: {
		screens: {
			sm: "640px",
			md: "768px",
			lg: "1024px",
			xl: "1330px",
			"2xl": "1330px",
			"lg-down": {
				max: "1329px",
			},
			"md-down": {
				max: "1023px",
			},
			"sm-down": {
				max: "767px",
			},
			"sm-only": {
				max: "669px",
			},
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			black: "#000000",
			white: "#ffffff",
			primary: {
				DEFAULT: "#171746",
				50: "#edf3ff",
				100: "#dfe8ff",
				200: "#c5d5ff",
				300: "#a2b8ff",
				400: "#7d90fc",
				500: "#5e6bf6",
				600: "#4041eb",
				700: "#3433cf",
				800: "#2c2da7",
				900: "#2b2e84",
				950: "#171746",
			},
			secondary: {
				DEFAULT: "#ED5E4F",
				50: "#fef3f2",
				100: "#fee5e2",
				200: "#fdd0cb",
				300: "#fbaea6",
				400: "#f67f73",
				500: "#ed5e4f",
				600: "#d93a29",
				700: "#b62d1f",
				800: "#97291d",
				900: "#7d281f",
				950: "#44100b",
			},
			accent: {
				DEFAULT: "#E20559",
				50: "#fff0f3",
				100: "#ffe2e8",
				200: "#ffc9d7",
				300: "#ff9db7",
				400: "#ff6692",
				500: "#ff3171",
				600: "#f00e5e",
				700: "#e20559",
				800: "#aa074a",
				900: "#910a45",
				950: "#520022",
			},
			green: {
				DEFAULT: "#298747",
				50: "#f2fbf5",
				100: "#e1f7e7",
				200: "#c4eed1",
				300: "#96dfac",
				400: "#60c881",
				500: "#3aad5e",
				600: "#298747",
				700: "#25703d",
				800: "#225934",
				900: "#1d4a2d",
				950: "#0b2816",
			},
			purple: {
				DEFAULT: "#31006f",
				50: "#f4f1ff",
				100: "#ede5ff",
				200: "#dcceff",
				300: "#c4a7ff",
				400: "#a976ff",
				500: "#913fff",
				600: "#8718ff",
				700: "#7c07fa",
				800: "#6705d2",
				900: "#5606ac",
				950: "#31006f",
			},
			blue: {
				DEFAULT: "#196bac",
				50: "#f2f8fd",
				100: "#e4effa",
				200: "#c2def5",
				300: "#8cc4ed",
				400: "#4fa5e1",
				500: "#288acf",
				600: "#196bac",
				700: "#16588e",
				800: "#164a76",
				900: "#183f62",
				950: "#102841",
			},
			lightpurple: {
				DEFAULT: "#982a72",
				50: "#fcf3fa",
				100: "#f9eaf7",
				200: "#f6d4f0",
				300: "#efb2e2",
				400: "#e581ce",
				500: "#d85cb8",
				600: "#c63c9c",
				700: "#aa2c80",
				800: "#982a72",
				900: "#76255a",
				950: "#471034",
			},
			warmwhite: "#FFFCF5",
			coldwhite: "#F6F3ED",
		},
		margin: {
			container: "15px",
		},
		borderRadius: {
			button: "23px",
		},
		boxShadow: {
			card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
			callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
		},
	},
};
